import React from 'react';
import { PlanUsage } from '~/types/models';
import { Label } from './Label';

export interface UsagesPanelProps {
  usages?: PlanUsage[];
}

export function UsagesPanel({ usages }: UsagesPanelProps) {
  return (
    <div className='flex flex-col gap-y-4'>
      <Label>Usage</Label>
      <div className='flex flex-row flex-wrap items-center gap-x-6'>
        {usages?.map((usage) => {
          return (
            <span
              key={usage.title}
              className='flex flex-row gap-x-8 flex v2-text-neutral-900 items-center'
            >
              <span className='flex flex-row gap-x-1.5 items-center flex-wrap'>
                <span className='font-bold text-base'>{usage?.title}</span>
                {usage?.subtitle && (
                  <span className='v2-text-neutral-500 text-sm leading-3'>
                    {usage?.subtitle}
                  </span>
                )}
              </span>
              <span className='font-bold text-base'>
                {usage?.limit == null ? (
                  <>&infin;</>
                ) : usage?.limit == 0 ? (
                  usage?.count.toLocaleString()
                ) : (
                  `${usage?.count?.toLocaleString()}/${usage?.limit?.toLocaleString()}`
                )}
              </span>
            </span>
          );
        })}
      </div>
    </div>
  );
}
